import { ENV } from "src/constant";
import { ChatService } from "src/modules/Chat/service";

const tracking = (code, options: any = undefined) => {
    let extData;
    if (options) {
        try {
            extData = JSON.stringify(options);
        } catch (error) {
            console.log("error");
        }
    }

    if (!ENV.PROD) return; 

    ChatService.tracking({
        cateId: "mJ1Pr0Pf77pG5rYdd6QDo3AuuyNnTOwGbl15BtBUuMQ=",
        cmd: "9000",
        subCmd: code?.toString(),
        data: extData !== undefined ? ["0", extData] : ["0"],
    });
};
export default tracking;
